// extracted by mini-css-extract-plugin
export default {"bannerButton":"CookieConsent_bannerButton__GGbiV","banner":"CookieConsent_banner__98CBH"};